import type { PostHogContextRef } from '../context'

/**
 * Where the community header link was clicked. `user_menu` is the real entry
 * point: the owner-community profile link in the user avatar dropdown
 * (`Menu.renderProfile`, threaded via `MenuUser`) → `/profile/<uuid>`. The
 * `desktop*` / `mobile*` values are legacy primary-nav sources kept for
 * back-compat; no current call site emits them.
 */
export type CommunityHeaderLinkSource =
  | 'desktop'
  | 'desktop_dropdown'
  | 'mobile'
  | 'mobile_dropdown'
  | 'user_menu'

/**
 * Community navigation / header events. `community_header_link_clicked` fires
 * once when the user clicks their community profile link in the user avatar
 * dropdown (source: 'user_menu'). Payload: { context: 'community', source }.
 */
export type HeaderEvents = {
  community_header_link_clicked: (source: CommunityHeaderLinkSource) => void
}

export function createHeaderEventCallbacks (
  contextRef: PostHogContextRef,
): HeaderEvents {
  return {
    community_header_link_clicked: (source: CommunityHeaderLinkSource) => {
      const ctx = contextRef.current
      if (!ctx.posthogClient) return
      ctx.posthogClient.capture('community_header_link_clicked', {
        context: 'community',
        source,
      })
    },
  }
}
